import ApplicationAdapter from "./application";

export default class DnssecRecordAdapter extends ApplicationAdapter {
  urlForCreateRecord(_, snapshot) {
    return `${this.apiBaseUri}/domain/adddnssecrecord?domainname=${snapshot.belongsTo("domain").id}`;
  }

  urlForDeleteRecord(id, _, snapshot) {
    return `${this.apiBaseUri}/domain/deletednssecrecord?domainname=${snapshot.belongsTo("domain").id}&recordid=${id}`;
  }
}
